import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, of, switchMap } from 'rxjs';

import { ModalType } from '@connect-services/client/components/abstract-modal/abstract-modal.component';
import { bypassDeactivateModal } from '@connect-services/client/guards/can-dismount.guard';
import { RouterService } from '@connect-services/client/services/router.service';

export interface CanDeactivateDialogConfig {
    cancelLabel?: string;
    confirmLabel?: string;
    description?: string;
    title?: string;
    type: ModalType;
    width?: string;
}

export interface CanDeactivateComponent {
    canDeactivateComponent: () => boolean;
    confirmDeactivateComponent: () => void;
    getComponentDeactivateDialogConfig: () => CanDeactivateDialogConfig;
}

export function canDeactivateGuard(component: CanDeactivateComponent): Observable<boolean> {
    const routerService = inject(RouterService);
    const router = inject(Router);

    if (router.currentNavigation()?.extras?.info === bypassDeactivateModal || component.canDeactivateComponent()) {
        return of(true);
    }

    return from(routerService.confirmBeforeLeavingPage(component.getComponentDeactivateDialogConfig())).pipe(
        switchMap((confirmed: boolean) => {
            if (!confirmed) {
                return of(false);
            }

            component.confirmDeactivateComponent();

            return of(true);
        }),
    );
}
